import Navigation from './modules/navigation';

import './modules/legacy/general';
import './modules/legacy/bilia';

import ScrollHandle from './modules/scroll-handle';
import Gtm from './modules/gtm';
import ga4 from './modules/ga4';
import maps from './modules/maps/maps.js';

maps.init();

document.addEventListener('DOMContentLoaded', () => {
  if(document.querySelector('.vehicle-search')) {
    import('./modules/vehicle-search').then((m)=>m.default.init());
  }
  if(document.querySelector('#search-watcher')) {
    import('./modules/search-watcher').then((m)=>m.default.init());
  }
  if(document.querySelector('.contact-us-form')) {
    import('./modules/contact-form').then((m)=>m.default.init());
  }

  if(document.querySelector('.buy-car-form')) {
    import('./modules/buy-car-form').then((m)=>m.default.init());
  }

  if(document.querySelector('.bilia-card-form')) {
    import('./modules/bilia-card-form').then((m)=>m.default.init());
  }

  if(document.querySelector('.tirerate-contact-form')) {
    import('./modules/tirerate-contact-form').then((m)=>m.default.init());
  }

  if(document.querySelector('#vehicle-page')) {
    import('./modules/vehicle-page').then((m)=>m.default.init());
    import('./modules/funding-calculator').then((m)=>m.default.init());
    import('./modules/vehicle-images').then((m)=>m.default.init());
  }
  if(document.querySelector('.js-multiselect, .js-select')) {
    import('./modules/dropdowns').then(m => m.default.init());
  }
  if(document.querySelector('#carReserveForm,input[name="reserveTime"]')) {
    import('./modules/legacy/reserveCar');
  }
  if(document.getElementById('buy-car-page')) {
    import('./modules/legacy/buyCar');
    import('./modules/funding-calculator').then((m)=>m.default.init());
  }
  if(document.querySelector('.workers-list-form')) {
    import('./modules/legacy/workers-list');
  }
  if(document.querySelector('#carBuyFinanceForm')) {
    import('./modules/legacy/santander');
  }
  if(document.querySelector('.damage-assessment-form')) {
    import('./modules/legacy/damage.assessment');
  }
  if(document.querySelector('[data-email-local-part]')){
    import('./modules/legacy/antispam');
  }
  if(document.getElementById('js-branch-bar')) {
    import('./modules/branch-bar').then(({branchBar})=>branchBar.init());
  }
  if(document.querySelector('[data-phased]')) {
    import('./modules/phaser').then(m=>new m.default());
  }
  if(document.querySelector('#adw-date,#adw-location')){
    import('./modules/awd-form').then((m)=>m.default.init());
  }
  if(document.querySelector('.collapsable-content')) {
    import('./modules/collapsible').then(m=> m.default.init());
  }
  if(document.querySelector('.accordion')) {
    import('./modules/accordion').then(m => m.default.init());
  }
  if(document.querySelector('#lianamailer')) {
    import('./modules/lianamailer').then(m => m.default.init());
  }
  if(document.querySelector('.tabs-element')) {
    import('./modules/tabs-element').then(m => m.default.init());
  }
  if(document.querySelectorAll('.stage-form').length) {
    import('./modules/stage-form').then(m => m.default.init());
  }

  const sliders = document.querySelectorAll('.slider');

  if(sliders.length) {
    import('./modules/slider').then(m => m.default.init(sliders));
  }

  if(document.querySelector('dialog.generic-dialog')) {
    import('./modules/generic-dialog').then((module) => {
      const GenericDialog = module.default;
      GenericDialog.init();
    });
  }

  if(document.querySelectorAll('.js-text-field').length) {
    import('./modules/text-field').then(m => m.default.init());
  }

  // Vehicle image carousel

  const vehicleImageCarousels = document.getElementsByClassName('vehicle-image-carousel');
  if (vehicleImageCarousels && vehicleImageCarousels.length) {
    import('./modules/vehicle-image-carousel').then((m) => m.default.init());
  }

  // Horizontal vehicle carousels

  const horizontalVehicleCarousels = document.getElementsByClassName('swiper-horizontal-vehicle');
  if (horizontalVehicleCarousels && horizontalVehicleCarousels.length) {
    import('./modules/carousel-horizontal-vehicle').then((m) => m.default.init('swiper-horizontal-vehicle'));
  }

  const horizontalOfferCarousels = document.getElementsByClassName('swiper-horizontal-offer');
  if (horizontalOfferCarousels && horizontalOfferCarousels.length) {
    import('./modules/carousel-horizontal').then((m) =>
      m.default.init('swiper-horizontal-offer', {768: {slidesPerView: 2.5, spaceBetween: 8}, 1200: {slidesPerView: 4, spaceBetween: 24}}));
  }

  const newVehicleCarousels = document.getElementsByClassName('swiper-new-vehicles');
  if (newVehicleCarousels && newVehicleCarousels.length) {
    import('./modules/carousel-new-vehicles').then((m) => m.default.init('swiper-new-vehicles'));
  }

  const horizontalNewsCarousels = document.getElementsByClassName('swiper-horizontal-news');
  if (horizontalNewsCarousels && horizontalNewsCarousels.length) {
    import('./modules/carousel-horizontal').then((m) =>
      m.default.init('swiper-horizontal-news', {768: {slidesPerView: 2, spaceBetween: 24}}));
  }

  if (document.querySelector('.modal-button')) {
    import('./modules/modals').then(m => m.default.init());
  }

  const damagePhotosForms = document.querySelectorAll('.damage-photos-form')

  if (damagePhotosForms) {
    import('./modules/damage-photos-form').then(m => m.default.init(damagePhotosForms));
  }

  if (document.querySelector('.contact-form-modal-button')) {
    import('./modules/private-leasing-contact-form').then(m => m.default.init());
  }

  if (document.querySelector('.open-application-form-button')) {
    import('./modules/open-application-form').then(m => m.default.init());
  }

  const privateLeasingCalculatorElements = document.querySelectorAll('.private-leasing-calculator');

  if (privateLeasingCalculatorElements.length) {
    import('./modules/private-leasing-calculator').then((module) => {
      module.default.init(privateLeasingCalculatorElements);
    });
  }

  const privateLeasingLandingFilters = document.getElementById('private-leasing-landing-filters');

  if (privateLeasingLandingFilters) {
    import('./modules/private-leasing/private-leasing-filters').then((module) => {
      module.default.init(privateLeasingLandingFilters);
    });
  }

  const tireRates = document.querySelectorAll('.tirerates');

  if(tireRates.length > 0) {
    import('./modules/tirerates').then((module) => {
      module.default.init(tireRates);
    });
  }

  const calendarTimePickerElements = document.querySelectorAll('.leasing-return-calendar-js');

  if(calendarTimePickerElements.length > 0) {
    import('./modules/leasing-return-calendar').then((module) => {
      module.default.init(calendarTimePickerElements);
    });
  }

  const halfAccordionElements = document.querySelectorAll('.half-accordion-js');

  if(halfAccordionElements.length > 0) {
    import('./modules/half-accordion').then((module) => {
      module.default.init(halfAccordionElements);
    });
  }

  const carContactForm = document.querySelector('#car-contact-form');
  if(carContactForm) {
    import('./modules/car-contact-form').then(module => {
      const ContactFormCarInfo = module.default;
      const instance = new ContactFormCarInfo(carContactForm);
      instance.findElements();
      instance.addEventListeners();
    });
  }

  /* Mobile Service Form */
  const mobileServiceForm = document.forms['mobile-service-form'];
  if(mobileServiceForm) {
    import('./modules/mobile-service-form').then(module => {
      const MobileServiceFormClass = module.default;
      const instance = new MobileServiceFormClass(mobileServiceForm);
      instance.init();
    });
  }

  /* Mobile Service Map */
  const mobileServiceMap = document.querySelector('.mobile-service-map');
  if(mobileServiceMap) {
    import('./modules/mobile-service-map/mobile-service-map').then(module => {
      const MobileServiceMap = module.default;
      const instance = new MobileServiceMap(mobileServiceMap);
      instance.init();
    });
  }

  import('./modules/cmtoken').then((module) => {
    module.default();
  });

  Navigation.init();
  Gtm.init();
  ga4.init();

  ScrollHandle.init();
});
